import { render } from "./CopyBox.vue?vue&type=template&id=2f42b7a6&scoped=true&ts=true"
import script from "./CopyBox.vue?vue&type=script&lang=ts"
export * from "./CopyBox.vue?vue&type=script&lang=ts"

import "./CopyBox.vue?vue&type=style&index=0&id=2f42b7a6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f42b7a6"]])

export default __exports__